import { AmberHoc, AmberHocProps } from '../../../util';
import {
  DeclineSensorGeneratedGrainTicketMutation as Result,
  DeclineSensorGeneratedGrainTicketMutationVariables as Variables,
  withDeclineSensorGeneratedGrainTicket as HOC,
} from '../__generated';
import { GraphQLErrors } from './error';

export type WithDeclineSensorGeneratedGrainTicketHocChildProps = {
  declineSensorGeneratedGrainTicket: (
    variables: Variables
  ) => Promise<Result['declineSensorGeneratedGrainTicket']>;
};

export const withDeclineSensorGeneratedGrainTicketHoc: AmberHoc<
  {},
  WithDeclineSensorGeneratedGrainTicketHocChildProps
> = (component) =>
  HOC<
    AmberHocProps<{}, WithDeclineSensorGeneratedGrainTicketHocChildProps, typeof component>,
    WithDeclineSensorGeneratedGrainTicketHocChildProps
  >({
    options: { errorPolicy: 'all' },
    props: (props) => {
      const { mutate } = props;
      return {
        declineSensorGeneratedGrainTicket: async (variables) => {
          if (!mutate) {
            throw new Error('Unexpected UI error');
          }

          const result = await mutate({ variables });

          if (!result) {
            throw new Error('Unexpected server response');
          }

          const { errors, data } = result;
          if (errors) {
            throw new GraphQLErrors(errors);
          }
          if (!data) {
            throw new Error('Unexpected server response');
          }
          return data.declineSensorGeneratedGrainTicket;
        },
      };
    },
  })(component as any);
